const ATTRIBUTION_KEY = 'agentomatic_ad_attribution';

export type AdAttribution = {
  landing_path?: string;
  utm_source?: string;
  utm_medium?: string;
  utm_campaign?: string;
  campaign_name?: string;
  campaignname?: string;
  utm_content?: string;
  utm_term?: string;
  kw?: string;
  search_term?: string;
  searchterm?: string;
  hook?: string;
  headline?: string;
  ad_headline?: string;
  ad_style?: string;
  variant?: string;
  angle?: string;
  audience?: string;
  ad_id?: string;
  adid?: string;
  ad_name?: string;
  ad_description?: string;
  ad_desc?: string;
  desc?: string;
  description?: string;
  description_id?: string;
  headline_id?: string;
  hook_id?: string;
  landing_id?: string;
  campaign_id?: string;
  campaign_batch?: string;
  asset_group?: string;
  asset_group_id?: string;
  assetgroupid?: string;
  assetid?: string;
  asset_id?: string;
  platform?: string;
  gclid?: string;
  gbraid?: string;
  wbraid?: string;
  gad_source?: string;
  gad_campaignid?: string;
  campaignid?: string;
  adgroupid?: string;
  ad_group_id?: string;
  adgroup?: string;
  ad_group?: string;
  ad_group_name?: string;
  adgroup_name?: string;
  adgroupname?: string;
  creative?: string;
  creativeid?: string;
  keyword?: string;
  matchtype?: string;
  network?: string;
  device?: string;
  placement?: string;
  targetid?: string;
  loc_physical_ms?: string;
  loc_interest_ms?: string;
  adposition?: string;
  msclkid?: string;
  twclid?: string;
  captured_at?: string;
};

type RememberAttributionOptions = {
  replaceExisting?: boolean;
};

const PARAM_KEYS: Array<keyof AdAttribution> = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'campaign_name',
  'campaignname',
  'utm_content',
  'utm_term',
  'kw',
  'search_term',
  'searchterm',
  'hook',
  'headline',
  'ad_headline',
  'ad_style',
  'variant',
  'angle',
  'audience',
  'ad_id',
  'adid',
  'ad_name',
  'ad_description',
  'ad_desc',
  'desc',
  'description',
  'description_id',
  'headline_id',
  'hook_id',
  'landing_id',
  'campaign_id',
  'campaign_batch',
  'asset_group',
  'asset_group_id',
  'assetgroupid',
  'assetid',
  'asset_id',
  'platform',
  'gclid',
  'gbraid',
  'wbraid',
  'gad_source',
  'gad_campaignid',
  'campaignid',
  'adgroupid',
  'ad_group_id',
  'adgroup',
  'ad_group',
  'ad_group_name',
  'adgroup_name',
  'adgroupname',
  'creative',
  'creativeid',
  'keyword',
  'matchtype',
  'network',
  'device',
  'placement',
  'targetid',
  'loc_physical_ms',
  'loc_interest_ms',
  'adposition',
  'msclkid',
  'twclid',
];

function getLandingIdFromPath(pathname: string): string | undefined {
  const match = pathname.match(/^\/landing\/([^/?#]+)/);
  return match ? decodeURIComponent(match[1]).slice(0, 180) : undefined;
}

export function getCurrentUrlAttribution(extra?: Partial<AdAttribution>): AdAttribution {
  const params = new URLSearchParams(window.location.search);
  const next: AdAttribution = {};
  PARAM_KEYS.forEach((key) => {
    const value = params.get(key);
    if (value) next[key] = value.slice(0, 180);
  });
  const landingId = getLandingIdFromPath(window.location.pathname);
  if (landingId && !next.landing_id) next.landing_id = landingId;
  if (extra) {
    Object.entries(extra).forEach(([key, value]) => {
      if (value && PARAM_KEYS.includes(key as keyof AdAttribution)) {
        next[key as keyof AdAttribution] = String(value).slice(0, 180) as any;
      }
    });
  }
  if (Object.keys(next).length > 0) {
    next.landing_path = window.location.pathname;
    next.captured_at = new Date().toISOString();
  }
  return next;
}

export function rememberAttributionFromUrl(
  extra?: Partial<AdAttribution>,
  options: RememberAttributionOptions = {}
): AdAttribution {
  const next = getCurrentUrlAttribution(extra);
  if (Object.keys(next).length === 0) return getRememberedAttribution();

  try {
    const existing = options.replaceExisting ? {} : getRememberedAttribution();
    const merged = { ...existing, ...next };
    window.localStorage.setItem(ATTRIBUTION_KEY, JSON.stringify(merged));
    return merged;
  } catch {
    return next;
  }
}

export function getRememberedAttribution(): AdAttribution {
  try {
    const raw = window.localStorage.getItem(ATTRIBUTION_KEY);
    if (!raw) return {};
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === 'object' ? parsed : {};
  } catch {
    return {};
  }
}

export function buildAttributionQuery(extra?: Record<string, string | undefined>): string {
  const attribution = getRememberedAttribution();
  const params = new URLSearchParams();
  Object.entries({ ...attribution, ...extra }).forEach(([key, value]) => {
    if (value) params.set(key, value);
  });
  const query = params.toString();
  return query ? `?${query}` : '';
}
